import React, { useState, useEffect, useRef } from "react";
import "../CSS/WithdrawalDashboard.css";
import styles from '../CSS/AgentHome.module.css';

import { GoArrowRight } from "react-icons/go";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../AuthContext";

import Loading from '../Components/Loading';
import Error from '../Components/Error';

const WithdrawalDashboard = () => {
    const { fetchData, postData } = useAuth();

    const [loader, setLoader] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorText, setErrorText] = useState('');

    const [symbol, setSymbol] = useState('')
    const [withdrawals, setWithdrawals] = useState([]);
    const [rate, setRate] = useState(0)

    const [pending, setPending] = useState(0);
    const [balance, setBalance] = useState(0)

    const navigate = useNavigate();

    const displayError = (message) => {
        setIsError(true);
        setErrorText(message);

        const timerId = setTimeout(() => {
            setIsError(false);
            setErrorText('');
        }, 1500);

        return () => clearTimeout(timerId);
    }; 

    const isFirstRun = useRef(true);
    async function getData() {
        setLoader(true);

        try {
            const data = await fetchData('/admin/pending/withdrawal');
            setLoader(false);

            setWithdrawals(data.records);
            setSymbol(data.symbol);
            setRate(data.rate);
            setPending(data.pending);
            setBalance(data.balance)
        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }

    useEffect(() => {
        if (isFirstRun.current) {
            getData();
            isFirstRun.current = false;
        }
    }, [])

    async function payAction(action, orderId) {
        setLoader(true);

        try {
            const data = await postData('/admin/callback/withdraw/bank', { action, orderId });
            setLoader(false);

            setWithdrawals(prevData => prevData.filter(item => item.orderId !== orderId));
            setPending(data.pending);
            setBalance(data.balance)
        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }

    return (
        <div className="dashboard">
            {loader && <Loading />}
            {isError && <Error errorMsg={errorText} />}

            <div className={styles.topbar}>
                <div className={styles.left}>
                    <h1>Pending Withdrawals</h1>
                </div>

                <div className={styles.right} style={{
                    display: "flex",
                    alignItems: "center",
                }} onClick={() => navigate(-1)}>
                    <div>Go Back</div>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: 20
                    }}>
                        <GoArrowRight />
                    </div>
                </div>
            </div>

            <div className="summary-container">
                <div className="card">
                    <h2>Available Balance</h2>
                    <p className="amount">{balance}<span> {symbol}</span></p>
                    <p>${balance * rate} USD</p>
                </div>
                <div className="card">
                    <h2>Total Pending Withdrawals</h2>
                    <p className="amount">{pending.amount}<span> {symbol}</span></p>
                    <p>${pending.amount * rate} USD</p>
                </div>
            </div>

            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Order ID</th>
                            <th>Withdrawal Amount</th>
                            <th>Banking Details</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {withdrawals.map((w, i) => (
                            <tr key={i}>
                                <td>
                                    <div>{w.orderId}</div>
                                    <div className="subtext">{w.date}</div>
                                </td>
                                <td>
                                    <div>{w.convertedAmount} {symbol}</div>
                                    <div className="subtext">In USD: {w.amount}$</div>
                                </td>
                                <td>
                                    <div>{w.details?.bankName}</div>
                                    <div className="subtext">{w.details?.accountNo}</div>
                                    <div className="subtext">{w.details?.holderName}</div>
                                </td>
                                <td>
                                    <button className="btn approve" onClick={() => payAction('approve', w.orderId)}>Approve</button>
                                    <button className="btn decline" onClick={() => payAction('reject', w.orderId)}>Decline</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default WithdrawalDashboard;